import {
  assetsApi,
  type BatchOnboardVehiclesV2ApiArg,
  type BatchOnboardVehiclesV2ApiResponse,
  type ExportAssetBatteryReadinessCsvV20260113ApiArg,
  type ExportAssetBatteryReadinessCsvV20260113ApiResponse,
  type ExportPendingConnectionVehiclesApiArg,
  type ExportPendingConnectionVehiclesApiResponse,
  type ExportPendingOnboardingVehiclesApiArg,
  type ExportPendingOnboardingVehiclesApiResponse,
  type ExportVehicleDiagnosticsListApiArg,
  type ExportVehicleDiagnosticsListApiResponse,
  type ExportVehicleListOverviewCsvFromSearchApiArg,
  type ExportVehicleListOverviewCsvFromSearchApiResponse,
} from './assetsApi';

assetsApi.injectEndpoints({
  endpoints: (build) => ({
    exportPendingConnectionVehicles: build.mutation<
      ExportPendingConnectionVehiclesApiResponse,
      ExportPendingConnectionVehiclesApiArg
    >({
      query: (queryArg) => ({
        url: '/2025-10-07/views/pendingConnectionVehicles/export',
        method: 'POST',
        body: queryArg.pendingVehicleExportRequest,
        headers: {
          'cs-organization': queryArg['cs-organization'],
          'cs-fleet': queryArg['cs-fleet'],
        },
        params: {
          size: queryArg.size,
          vin: queryArg.vin,
          subscriberAccountNumber: queryArg.subscriberAccountNumber,
          accountOwnerEmailId: queryArg.accountOwnerEmailId,
          fan: queryArg.fan,
          stationId: queryArg.stationId,
          pendingConnectionStatuses: queryArg.pendingConnectionStatuses,
          vehicleYear: queryArg.vehicleYear,
          vehicleMakes: queryArg.vehicleMakes,
          vehicleModel: queryArg.vehicleModel,
        },
        responseHandler: 'text',
      }),
      invalidatesTags: ['dashboard-view-controller'],
    }),
    exportPendingOnboardingVehicles: build.mutation<
      ExportPendingOnboardingVehiclesApiResponse,
      ExportPendingOnboardingVehiclesApiArg
    >({
      query: (queryArg) => ({
        url: '/2025-10-07/boarding/vehicles/pending/export',
        method: 'POST',
        body: queryArg.pendingVehicleExportRequest,
        headers: {
          'cs-organization': queryArg['cs-organization'],
          'cs-fleet': queryArg['cs-fleet'],
        },
        params: {
          size: queryArg.size,
          status: queryArg.status,
          reviewReasons: queryArg.reviewReasons,
          fan: queryArg.fan,
          subscriberAccountNumber: queryArg.subscriberAccountNumber,
          accountOwnerEmailId: queryArg.accountOwnerEmailId,
          stationId: queryArg.stationId,
          vehicleYear: queryArg.vehicleYear,
          vehicleMakes: queryArg.vehicleMakes,
          vehicleModel: queryArg.vehicleModel,
        },
        responseHandler: 'text',
      }),
      invalidatesTags: ['vehicle-boarding-workflow-session-controller'],
    }),
    exportVehicleListOverviewCsvFromSearch: build.mutation<
      ExportVehicleListOverviewCsvFromSearchApiResponse,
      ExportVehicleListOverviewCsvFromSearchApiArg
    >({
      query: (queryArg) => ({
        url: '/2026-03-10/views/vehicleOverviewList/export',
        method: 'POST',
        body: queryArg.vehicleOverviewSearchRequest,
        headers: {
          'cs-organization': queryArg['cs-organization'],
          'cs-fleet': queryArg['cs-fleet'],
        },
        params: {
          timezone: queryArg.timezone,
        },
        responseHandler: 'text',
      }),
      invalidatesTags: ['vehicle-list-overview-controller'],
    }),
    exportVehicleDiagnosticsList: build.mutation<
      ExportVehicleDiagnosticsListApiResponse,
      ExportVehicleDiagnosticsListApiArg
    >({
      query: (queryArg) => ({
        url: '/2026-01-13/views/vehicleDiagnosticsList/export',
        method: 'POST',
        body: queryArg.bdPageRequest,
        headers: {
          'cs-organization': queryArg['cs-organization'],
          'cs-fleet': queryArg['cs-fleet'],
        },
        params: {
          timezone: queryArg.timezone,
          locale: queryArg.locale,
          timeZone: queryArg.timeZone,
          distanceUnit: queryArg.distanceUnit,
        },
        responseHandler: 'text',
      }),
      invalidatesTags: ['vehicle-diagnostics-list-controller'],
    }),
    exportAssetBatteryReadinessCsvV20260113: build.mutation<
      ExportAssetBatteryReadinessCsvV20260113ApiResponse,
      ExportAssetBatteryReadinessCsvV20260113ApiArg
    >({
      query: (queryArg) => ({
        url: '/2026-01-13/views/batteryReadinessReport/export',
        method: 'POST',
        body: queryArg.bdPageRequest,
        headers: {
          'cs-organization': queryArg['cs-organization'],
          'cs-fleet': queryArg['cs-fleet'],
        },
        params: {
          requestBody: queryArg.requestBody,
          locale: queryArg.locale,
          timeZone: queryArg.timeZone,
          distanceUnit: queryArg.distanceUnit,
        },
        responseHandler: 'text',
      }),
      invalidatesTags: ['battery-readiness-report-view-controller'],
    }),
    batchOnboardVehiclesV2: build.mutation<
      BatchOnboardVehiclesV2ApiResponse,
      BatchOnboardVehiclesV2ApiArg
    >({
      query: (queryArg) => {
        const formData = new FormData();
        const { file } = queryArg.body;
        const filename =
          typeof File !== 'undefined' && file instanceof File
            ? file.name
            : 'vins.csv';
        formData.append('file', file, filename);
        return {
          url: '/2025-01-14/boarding/vehicles/onboard',
          method: 'POST',
          body: formData,
          formData: true,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'X-Boarding-Connection-Policy':
              queryArg['X-Boarding-Connection-Policy'],
          },
          params: {
            remoteProvider: queryArg.remoteProvider,
            telemetryProvider: queryArg.telemetryProvider,
            uploadType: queryArg.uploadType,
          },
        };
      },
      invalidatesTags: ['batch-boarding-vehicles-controller'],
    }),
  }),
  overrideExisting: true,
});

export { assetsApi };
